import React from "react";
import "./Loading.css";
export default function () {
  return (
    <div className="center">
      <div className="text">Loading</div>
      <div className="ring"></div>
    </div>
  );
}
